import Request from './request'
import consts from "@/consts.js"
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'

async function fetch(data) {
    return Request('get', "api/stock-outs", data);
}

async function fetchOne(id, data) {
    return Request('get', "api/stock-outs/" + id, data);
}

async function distributionPrint(id) {// 打印配送单
    return Request('get', "api/stock-outs/distribution-print/" + id)
}

async function distributionsPrint(data) {// 批量打印配送单
    data.limit = consts.limitAll; //获取全部
    data.itemsPerPage = consts.limitAll; //获取全部
    return Request('get', "api/stock-outs/distributions-print", data)
}

async function add(data) {// 编辑出库单
    //data = delSomeFields(data);// 去除过多杂项
    return Request('post', "api/stock-outs/add", data);
}

async function edit(id, data) {// 编辑出库单
    return Request('patch', "api/stock-outs/edit/" + id, data);
}

async function partOut(data) {
    return Request('post', "api/stock-outs/part-out", data)
}

async function out(data) {
    return Request('post', "api/stock-outs/out", data)
}

async function approve(id) {// 审批出库单
    return Request('get', "api/stock-outs/approve/" + id);
}

async function cancel(id) {// 作废出库单
    return Request('get', "api/stock-outs/cancel/" + id);
}

async function packConfirm(data) {
    return Request('get', "api/waves/get-confirm-wave-detail", data);
}

async function submitPackConfirm(data) {
    return Request('post', "api/stock-outs/pack-confirm", data);
}

async function orderOutPrint(id) {
    return Request('get', 'api/stock-outs/stock-order-print/' + id)
}

async function stockOrdersOutPrint(data) {
    return Request('get', 'api/stock-outs/stock-orders-print/', data)
}

async function stockOrdersOutMergePrint(data) {
    return Request('get', 'api/stock-outs/shop-stock-orders-print/', data)
}

async function distributionsMergePrint(data) {
    return Request('get', 'api/stock-outs/shopDistributionsPrint/', data)
}

async function deliverDetailPrint(id) {// 发货单明细打印
    return Request('get', "api/stock-outs/distribution-print/" + id)
}

async function batchOut(data) { //批量出库
    return Request('get', "api/stock-outs/batch-out-exe", data, false, false, true)
}

async function getBatchOutProcess(guid) {
    return Request('get', 'api/stock-outs/get-batch-out-process?guid=' + guid)
}

async function pushAgain(id) {
    return Request('post', "api/shuhai/receive-sale-order/" + id);
}

async function exportDetail(id) {
    // 明细导出报表
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-outs/detail-export/' + id)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function exportOutSortingDetail(id) {
    // 发货明细导出报表
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-outs/out-sorting-export/' + id)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function batchExport(data) {
    // 出库单明细批量导出
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-outs/batch-detail-price-export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function batchDetailPriceSubAccountExport(data) {
    // 出库单（分账详情）导出
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-outs/batch-detail-price-sub-account-export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function batchDistributionsExport(data) {
    // 出库单明细批量导出
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-outs/distribution-detail-batch-export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function shopMergeExport(data) {
    // 出库单合并导出
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-outs/shop-merge-export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}
async function materialMergeExport(data) {
    // 商品汇总导出
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-outs/material-merge-export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}
async function disUserMergeExport(data) {
    // 线路汇总导出
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-outs/dis-user-merge-export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function fetchSortingOutSetting(id) {
    // 分拣出库设置
    return Request('get', "api/stock-outs/sorting-out-setting?stock_id=" + id);
}

async function saveSortingOutSetting(data) {
    // 分拣出库设置保存
    return Request('post', "api/stock-outs/sorting-out-setting-save", data);
}

async function fetchSortingOutView(id) {
    // 分拣出库详情获取
    return Request('post', "api/stock-outs/sorting-out-view?id=" + id);
}

async function saveCommonSortingOut(data) {
    // 分拣出库设置保存
    return Request('post', "api/stock-outs/common-sorting-out", data);
}

async function speech(name) {
    // 语音播报
    return Request('post', "api/stock-outs/speech/" + name + "/1");
}
async function getWeightPickAndSorting(data) {
    return Request('get', "api/stock-outs/get-weight-pick-and-sorting", data);
}

async function batchSortingOut(data) {
    return Request('get', "api/stock-outs/batch-sorting-out", data);
}

async function getOutDetailsGroupMaterial(data) {
    return Request('get', "api/stock-outs/get-out-details-group-material", Object.assign({},data,{
        itemsPerPage: consts.limitAll,// 获取全部
        limit: consts.limitAll,// 获取全部
    }));
}

async function manualSplit(data) {
    return Request('post', "api/stock-outs/manual-split", data);
}

async function getPartOutRelations(id) {
    return Request('get', "api/stock-outs/getPartOutRelations/" + id);
}

//待出库统计查询
async function waitOutMaterialAnalyses(data) {
    return Request('get', "api/stock-outs/waitOutMaterialAnalyses" , data);
}

async function shopExport(data) {
    // 待出库统计查询按门店批量导出
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-outs/waitOutMaterialAnalyseGroupShopExport', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function materialExport(data) {
    // 待出库统计查询按商品批量导出
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-outs/waitOutMaterialAnalyseGroupMaterialExport', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function batchOutNumRecall() {
    return Request('get', "api/stock-outs/batch-out-num-recall");
}

async function update(data) {
    return Request('post', 'api/stock-outs/update', data)
}

async function editEstimatedExpress(id, data) {
    return Request('post', 'api/stock-outs/edit-estimated-express/' + id, data)
}

async function getSortingTask(data) {
    return Request('get', 'api/stock-outs/get-sorting-task', data)
}

async function removeMaterial(id,data) {
    return Request('post', 'api/StockOuts/removeSortingTaskMaterial/' + id, data)
}

async function removePosition(id,data) {
    return Request('post', 'api/StockOuts/removeSortingTaskPosition/' + id, data)
}

async function removeCategory(id,data) {
    return Request('post', 'api/StockOuts/removeSortingTaskCategory/' + id, data)
}

async function requisitionMergeExport(data) {
    // 调拨单合并导出
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-outs/requisitionMergeExport', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function sortingMaterialMergeExport(data) {
    // 分拣商品汇总下载
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-outs/sortingMaterialMergeExport', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}
async function requisitionOutMergePrint(data){ 
  return Request('get', 'api/stock-outs/requisitionOutMergePrint/', data)
}

async function outTemplateExport(data) {
    // 入库单导入模板下载
    store.dispatch('fullscreenLoading')
    const response = await Request('get', "api/stock-outs/out-template-export", data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function imports(file, stockId) {// 出库单导入
    var data = new FormData();
    data.append("excel", file);
    data.append("stock_id", stockId);
    return Request('post', "api/stock-outs/get-out-template", data);
}

export default {
    fetch,
    fetchOne,
    distributionPrint,
    distributionsPrint,
    add,
    edit,
    partOut,
    out,
    approve,
    cancel,
    packConfirm,
    submitPackConfirm,
    orderOutPrint,
    stockOrdersOutPrint,
    stockOrdersOutMergePrint,
    distributionsMergePrint,
    deliverDetailPrint,
    batchOut,
    pushAgain,
    exportDetail,
    exportOutSortingDetail,
    batchExport,
    batchDetailPriceSubAccountExport,
    batchDistributionsExport,
    shopMergeExport,
    fetchSortingOutSetting,
    getSortingTask,
    saveSortingOutSetting,
    fetchSortingOutView,
    saveCommonSortingOut,
    speech,
    getWeightPickAndSorting,
    batchSortingOut,
    getOutDetailsGroupMaterial,
    manualSplit,
    getPartOutRelations,
    waitOutMaterialAnalyses,
    shopExport,
    getBatchOutProcess,
    materialExport,
    batchOutNumRecall,
    update,
    editEstimatedExpress,
    removeMaterial,
    removePosition,
    removeCategory,
    materialMergeExport,
    disUserMergeExport,
    requisitionMergeExport,
    sortingMaterialMergeExport,
    requisitionOutMergePrint,
    outTemplateExport,
    imports,
};